import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/store/AuthContext";
import { LogIn, LogOut, LayoutDashboard } from "lucide-react";

const AVATAR_URL = "https://customer-assets.emergentagent.com/job_sonny-beats-hub/artifacts/c1vkjchk_Smiling%20omar%20Chibi.png";

export default function NavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-40 glass" data-testid="nav-bar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-home-link">
          <img
            src={AVATAR_URL}
            alt="SonnyMane"
            className="avatar-chibi"
            data-testid="nav-avatar"
          />
          <div className="font-display text-xl sm:text-2xl font-bold leading-none flex flex-col">
            <span className="text-[var(--text)] text-[10px] tracking-[0.2em] uppercase font-mono-cartoon">
              Studio of
            </span>
            <span className="mt-0.5">
              <span className="text-[var(--text)]">Sonny</span>
              <span className="text-[var(--primary)]">Mane</span>
              <span className="text-[var(--pink)]">Beatz</span>
            </span>
          </div>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2 text-sm">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `px-3 py-2 rounded-md font-semibold transition-all ${isActive ? "bg-[var(--secondary)] text-[var(--ink)] border-2 border-[var(--ink)]" : "text-[var(--text-dim)] hover:text-[var(--text)]"}`
            }
            data-testid="nav-marketplace-link"
          >
            Shop
          </NavLink>
          {user && user.role === "admin" ? (
            <>
              <NavLink
                to="/admin"
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md font-semibold transition-all flex items-center gap-1.5 ${isActive ? "bg-[var(--primary)] text-[var(--ink)] border-2 border-[var(--ink)]" : "text-[var(--text-dim)] hover:text-[var(--text)]"}`
                }
                data-testid="nav-admin-link"
              >
                <LayoutDashboard className="w-4 h-4" /> Studio
              </NavLink>
              <button
                onClick={handleLogout}
                className="px-3 py-2 rounded-md text-[var(--text-dim)] hover:text-[var(--text)] flex items-center gap-1.5"
                data-testid="nav-logout-btn"
              >
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          ) : (
            <Link
              to="/admin/login"
              className="px-3 py-2 rounded-md text-[var(--text-dim)] hover:text-[var(--text)] flex items-center gap-1.5"
              data-testid="nav-admin-login-link"
            >
              <LogIn className="w-4 h-4" /> Producer
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
